const CreateTicket = () =>{
    return <h1>Home</h1>;
   }
   
   export default CreateTicket;